// Lightweight, safe formatter for quote Terms & Conditions.
// Supports: headings (# / ##), bold (**text**), bullets (- ), and
// blank-line separated paragraphs. Input is HTML-escaped first so it is
// safe to inject with dangerouslySetInnerHTML.
function esc(s) {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function inline(s) {
  // **bold**  then  *italic*
  return esc(s)
    .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
    .replace(/(^|[^*])\*([^*]+)\*(?!\*)/g, "$1<em>$2</em>");
}

export function termsToHtml(text) {
  if (!text || !String(text).trim()) return "";
  const lines = String(text).replace(/\r\n/g, "\n").split("\n");
  const out = [];
  let para = [];
  let list = [];
  const flushPara = () => {
    if (para.length) { out.push(`<p>${para.join("<br>")}</p>`); para = []; }
  };
  const flushList = () => {
    if (list.length) { out.push(`<ul>${list.map((li) => `<li>${li}</li>`).join("")}</ul>`); list = []; }
  };
  for (const raw of lines) {
    const line = raw.trim();
    if (!line) { flushPara(); flushList(); continue; }
    if (line.startsWith("## ")) { flushPara(); flushList(); out.push(`<h4>${inline(line.slice(3))}</h4>`); continue; }
    if (line.startsWith("# ")) { flushPara(); flushList(); out.push(`<h3>${inline(line.slice(2))}</h3>`); continue; }
    if (line.startsWith("- ") || line.startsWith("* ")) { flushPara(); list.push(inline(line.slice(2))); continue; }
    flushList();
    para.push(inline(line));
  }
  flushPara(); flushList();
  return out.join("");
}
